
import { defineComponent, onMounted, onUnmounted } from 'vue';

export default defineComponent({
  name: 'OtherLayout',
  setup() {
    onMounted(() => {
      document.body.classList.add('otherLayout');
    });
    onUnmounted(() => {
      document.body.classList.remove('otherLayout');
    });

    return {};
  },
});
